import { render } from "./register_image.vue?vue&type=template&id=899dda20"
import script from "./register_image.vue?vue&type=script&lang=js"
export * from "./register_image.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__